import React from 'react'
const styles = {
  fontFamily: "Roboto",
  fontSize: 18,
  lineHeight: 1.8,
  color: "#081528",
};
const TermsAndConditions = () => {
  return (
    <div className='mt-3 mr-3' style={{ marginLeft: "10%" }}>
      <div className='d-flex justify-content-center'>
        <h3>Terms And Conditions</h3>
      </div>
      <p style={styles}>
        Iyi sisitemu yubatswe n’Umujyi wa Kigali mu rwego rwo koroshya no kunoza
        gahunda y’irondo ry’umwuga rigendera ku mabwiriza
        <br /> y’umujyi wa Kigali (wayasanga kuri uru rubuga{" "}
        <a
          href='https://www.kigalicity.gov.rw'
          target='_blank'
          rel='noreferrer'
          style={{ color: "#6600FF " }}
        >
          https://www.kigalicity.gov.rw
        </a>{" "}
        ) ashingiye ku mabwirirza ya Minisitiri w’Ubutegetsi bw’Igihugu No
        001/07.01 yo ku wa 04/01/2013
        <br /> mu ngingo ya 14 ivuga inshingano z’ubuyobozi mu mikorere
        y’amarondo, n’ingingo ya 15 ivuga ikanagena abakora irondo
        n’abariyobora.
      </p>
      <p style={styles}>
        Irondo ry’umwuga rifite inshingano yo kurinda Umutekano w’abaturage mu
        Mudugudu. Inshingano mu buryo burambuye ni izi zikurikira:
        <br /> (1) gushaka makuru yose y’ibyahungabanya Umutekano agatangirwa
        igihe
        <br /> (2) gukumira ibyaha bitarabaho <br />
        (3) gutabara byihuse aho bibaye ngombwa <br />
        (4) kunganira izindi nzego zishinzwe kurinda Umutekano w’abaturage.
      </p>
      <p style={styles}>
        Iyi sisitemu izafasha uturere tugize umujyi wa Kigali kunoza imikorere
        y’irondo; kugenzura imikusanyirize n’imikoreshereze y’umusanzu
        w’umutekano.
        <br /> Izafasha kandi abaturage muri rusange Kwishyura byoroshye kandi
        byihuse umusanzu w’umutekano ndetse no kumenya byoroshye imyishyurire.
      </p>
      <p style={styles}>
        Buri wese wishyura umusanzu binyuze muri sisitemu yemeye amabwiriza yose
        agenga irondo ry’umwuga. Iyi sisitemu kandi yubatswe hitawe
        <br /> kw’Itegeko ryerekeye kurinda amakuru bwite n’imibereho bwite
        y’umuntu No 058/2021 ryo kuwa 13/10/2021 urarisanga kuri uru rubuga{" "}
        <a
          href='https://cyber.gov.rw/dpo/'
          target='_blank'
          rel='noreferrer'
          style={{ color: "#6600FF " }}
        >
          https://cyber.gov.rw/dpo/
        </a>
      </p>
      <p style={styles}>
        Uburenganzira bw’ukoresha iyi sisitemu Atanga amakuru ni ubu bukurikira:
        <br />
        (1) UBURENGANZIRA KU MAKURU BWITE – bitabangamiye nadi mategeko
        abigenga, wemerewe gusaba umugenzuzi w’amakuru cyangwa utunganya amakuru
        mu buryo bw’inyandiko cyangwa bw’ikoranabuhanga
        <div className='ml-5'>
          (A) amakuri yerekeye ikigamijwe mu gutunganya amakuru yawe bwite
          <br /> (B) kopi y’amakuru bwite
          <br /> (C) imiterere y’amakuru bwite ari muri iyi sisitemu harimo
          amakuru yererekey umwirondoro w’undi muntu cyangwa ibyiciro by’abandi
          bantu bafite cyangwa babonye amakuru bwite
          <br /> (D) inkomoko y’amakuru bwite mu gihe yakusanyijwe
          bitaguturutseho
          <br /> (E) kukumenyesha mu gihe amakuru bwite yoherejwe ahandi hantu.
        </div>
        <br /> (2) UBURENGANZI BOW GUSUBIZWA NO GUHEREREKANYA AMAKURU BWITE
        binyuze mu nyandiko cyangwa uburyo bw’ikoranabuhanga bisabwe umugenzuzi
        w’amakuru.
        <br /> (3) UBURENGANZIRA BWO KUBUZA GUTUNGANYA AMAKURU BWITWE MU GIHE
        KIGENWE iyo
        <div className='ml-5'>
          (A) ukuri kw’amakuru bwite guhakanwe na nyiri ubwite, mu gihe
          hakigenzurwa ukuri kwayo
          <br /> (B) kuyatunganya binyuranyije n’amategeko nyiri ubwite agasaba
          ihanagurwa ry’amakuru bwite cyangwa akabuza ikoreshwa ry’amwe muri ayo
          makuru bwite
          <br /> (C) nyiri ubwite yatambamiye itunganywa ry’amakuru bwite mu
          gihe hakigenzurwa niba hari impamvu zemewe umugenzuzi w’amakuru
          ashingiraho zirusha uburemere iza nyiri ubwite
        </div>
        (4) UBURENGANZIRA BWO GUSIBA AMAKURU BWITE: wasabi umugenzuzi w’amakuru
        gusiba amakuru bwite igihe:
        <div className='ml-5'>
          (A) amakuru bwite atagikenewe mu bijyanye n’icyari kigamijwe ubwo
          amakuru yakusanywaga cyangwa yatunganywaga;
          <br /> (B) nyiri ubwite yisubiyeho k’ukwemera kwe ari na ko
          kwashingiweho mu gutunganya amakuru bwite kandi nta yindi mpamvu
          yemewe n’amategeko y’iryo tunganywa;
          <br /> (C) nyiri ubwite atambamiye itunganywa ry’amakuru bwite kandi
          hakaba nta mpamvu yemewe y’iryo tunganywa;
          <br /> (D) amakuru bwite yatunganyijwe mu buryo bunyuranyije
          n’amategeko.
        </div>
        (5) UBURENGANZIRA BWO GUKOSORA: Nyiri ubwite afite uburenganzira bwo
        gusaba umugenzuzi w’amakuru mu buryo bw’inyandiko cyangwa
        bw’ikoranabuhanga gukosora amakuru bwite ye. Nyiri ubwite, iyo ari
        ngombwa, afite uburenganzira bwo gusaba ko amakuru bwite ye atuzuye
        yuzuzwa. Umugenzuzi w’amakuru, mu gihe kitarenze iminsi mirongo itatu
        (30) uhereye ku munsi yakiriyeho ubusabe, agomba kumenyesha nyiri ubwite
        mu buryo bw’inyandiko cyangwa bw’ikoranabuhanga ibijyanye no gukosora
        amakuru bwite ye.
        <br /> (6) UBURENGANZIRA BWO KUGENA UMUZUNGURA KU MAKURU BWITE Amakuru
        bwite ya nyiri ubwite ntazungurwa. Icyakora, iyo nyiri ubwite yakoze
        irage, Atanga uburenganzira busesuye cyangwa budasesuye ku muzungura we
        bwerekeye gutunganya amakuru bwite abitswe n’umugenzuzi w’amakuru
        cyangwa utunganya amakuru mu gihe agikenewe gukoreshwa
        <br /> (7) UBURENGANZIRA BWO GUHAGARARIRWA Uburenganzira bwa nyiri
        ubwite bwo guhagararirwa bwubahirizwa iyo nyiri ubwite:
        <div className='ml-5'>
          (A) atarageza ku myaka cumi n’itandatu (16) y’amavuko agahagararirwa
          n’umuntu umufiteho ububasha bwa kibyeyi cyangwa wagenwe
          nk’umwishingizi we <br />
          (B) afite ubumuga bw’umubiri kandi atabasha kwihagararira,
          agahagararirwa n’umubyeyi we, uwemeye kumubera umubyeyi ataramubyaye,
          ikigo cyangwa ishyirahamwe bimwitaho cyangwa umwishingizi wagenwe
          n’urukiko <br />
          (C) afite ubumuga bwo mu mutwe bwemejwe n’umuganga wemewe na Leta
          kandi atabasha kwihagararira, agahagararirwa n’umubyeyi we, uwemeye
          kumubera umubyeyi ataramubyaye, ikigo cyangwa ishyirahamwe bimwitaho
          cyangwa umwishingizi wagenwe n’urukiko; <br />
          (D) hari indi mpamvu, agahagararirwa n’umuntu wabiherewe burenganzira
          mu nyandiko na nyiri ubwite hakurikijwe amategeko abigenga.
        </div>
      </p>
      <p style={styles}>
        Inshingano n’uburenganzira by’uwishyura umusanzu
        <br /> (1) Kwishyurira umusanzu igihe ni ikuvuga ukibona fagitire.
        <br /> (2) Wemerewe guhabwa inyemeza-bwishyu igihe cyose umaze
        kwishyurwa
        <br /> (3) Gusaba ubufasha binyuze mu buryo bw’ikoranabuhanga (kurikiza
        intambwe zitangwa na sisitemu cyangwa ubarize ku murenge ubarizwamo
        bibaye ngombwa.
        <br />
        (4) Wemerewe kureba amafaranga urimo (ibirarane cyangwa agomba
        kwishyurwa)
        <br /> (5) Wemerewe Kwishyura amafaranga y’amezi ari imbere (advance)
        igihe bikoroheye
        <br /> (6) Wemerewe Kwishyura make make igihe udafite umusanzu wuzuye.
        <br /> (7) Ibibazo n’ibisubizo byibazwaho na benshi uzabisanga kuri 9031
        <br /> (8) Igihe ubisabye, uzahabwa uburyo sisitemu ikoreshwa mu buryo
        bwanditse (pdf flyer)
        <br /> (9) Wemereye abashinzwe imyishyurire y’umusanzu kukwibutsa igihe
        warengeje igihe cyo Kwishyura. Ibi bikorwa uhamagarwa cyangwa usurwa.
      </p>
      <p style={styles}>
        Ikaze kuri sisitemu y’umusanzu w’irondo ry’umwuga. Mu gukoresha iyi
        sisitemu wemeye amabwiriza agenga irondo ry’umwuga n’itegeko ryo kurinda
        amakuru bwite.{" "}
        <a
          href='https://www.kigalicity.co.rw'
          target='_blank'
          rel='noreferrer'
          style={{ color: "#6600FF " }}
        >
          https://www.kigalicity.co.rw
        </a>
      </p>
    </div>
  );
}

export default TermsAndConditions